import { Route } from 'react-router-dom';
import Biometrics from 'src/views/investor/Onboarding/onboarding_bioPhysical/Biometrics';
import BiometricsMoral from 'src/views/investor/Onboarding/onboarding_bioMoral/Biometrics';
import Risks from 'src/views/investor/Onboarding/onboardingRisks/risks';
import PhoneConfirmation from 'src/views/investor/Onboarding/onboardingPhone/phoneConfirmation';
import { AllowedUser } from 'src/routes/ProtectedRoute';
import SimafInfo from 'src/views/investor/Onboarding/onboarding_simaf/simaf';
import { ProtectedOnboardingRoute } from 'src/components/shared/compositionComponents/ProtectedOnboardingRoute/ProtectedOnboardingRoute';

const AllowedUseMoralConfig: AllowedUser = {
  user: 'investor',
  person: 'MORAL'
};

const AllowedUserPhysicalConfig: AllowedUser = {
  user: 'investor',
  person: 'FISICA'
};

export const OnboardingInvestorRoutes = (
  <Route path="/inversionista">
    <Route
      path="onboarding-data-f"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUserPhysicalConfig]}>
          <Biometrics />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-data-m"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUseMoralConfig]}>
          <BiometricsMoral />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-risks"
      element={
        <ProtectedOnboardingRoute
          allowedUsers={[...[AllowedUseMoralConfig, AllowedUserPhysicalConfig]]}
        >
          <Risks />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-perfil-uso"
      element={
        <ProtectedOnboardingRoute
          allowedUsers={[...[AllowedUseMoralConfig, AllowedUserPhysicalConfig]]}
        >
          <SimafInfo />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-phone"
      element={
        <ProtectedOnboardingRoute
          allowedUsers={[...[AllowedUseMoralConfig, AllowedUserPhysicalConfig]]}
        >
          <PhoneConfirmation />
        </ProtectedOnboardingRoute>
      }
    />
  </Route>
);
